import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import ModuleContainer from './views/ModuleContainer'
import StaticModuleContainer from './views/StaticModuleContainer'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import NotLoggedIn from './views/NotLoggedIn.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    /* {
      path: '/module/static/*',
      name: 'module-container',
      component: StaticModuleContainer,
      meta: {
        requiresAuth: true
      }
    }, */
    {
      path: '/module/:module',
      name: 'module-container',
      component: ModuleContainer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/module/:module/*',
      name: 'module-container',
      component: ModuleContainer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/not-logged-in',
      name: 'not-logged-in',
      component: NotLoggedIn
    },
  ]
})
